import axios from "axios";


export const AxiosCore = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_URL_API_KEY
    },
})